/* RESPONSIBLE TEAM: team-fin-qa */

import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

class AutomationFinAiAgentAnalyzeMonitorReviewsConversationRoute extends Route {
  analytics = {
    section: 'automation',
    place: 'fin-ai-agent.analyze.monitor.reviews.conversation',
  };

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(AutomationFinAiAgentAnalyzeMonitorReviewsConversationRoute, {
  overrideRenderTemplate: false,
});
